<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="statusOs.descricao"
                  data-cy="input-descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-descricao"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="statusOs.id"
            cols="12"
          >
            <b-form-group
              label="Ativo"
              label-for="v-check-button"
            >
              <b-form-checkbox
                v-model="statusOs.ativo"
                :checked="statusOs.ativo"
                data-cy="switch-ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
              >
                {{ statusOs.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_ORD_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_ORD_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import mixinsGlobal from '@/mixins'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('statusOsModule', {
      statusOs: state => state.statusOs,
    }),
    canEditOrInsert() {
      return (
        (!this.statusOs.id && this.verificarPermissao('ROLE_ORD_INSERIR'))
        || (this.statusOs.id && this.verificarPermissao('ROLE_ORD_ATUALIZAR'))
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Status OS',
      required,
    }
  },
  async mounted() {
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.statusOs.id) {
            this.$store
              .dispatch('statusOsModule/edit', this.statusOs)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('statusOsModule/insert', this.statusOs)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.$refs.form.reset()
              })
          }
        }
      })
    },
  },
}
</script>
